import { useCallback, useMemo } from 'react';
import { matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAbility } from '../abilities/components/AbilityProvider';
import { useDialog } from '../dialogs/components/DialogContext';
import { getRouteItems } from './routes';
import { selectUserIsRoot } from '../auth/selectors';
import { homePath } from './paths';

const addRoute = (carry, item) => {
    if (item.to && item.page) {
        carry.push(item);
    }
    if (item.pages) {
        item.pages.forEach((page) => {
            carry.push(page);
        });
    }
    if (item.items) {
        item.items.forEach((_item) => addRoute(carry, _item));
    }
};

export const useRouteItems = () => {
    const ability = useAbility();
    const isRoot = useSelector(selectUserIsRoot);

    const { openNewCustomerDialog } = useDialog();

    return useMemo(() => {
        const items = getRouteItems({ isRoot, ability, openNewCustomerDialog });

        const routes = items.reduce((carry, item) => {
            addRoute(carry, item);
            return carry;
        }, []);
        const orderedRoutes = [
            ...routes.filter((route) => route.exact !== false),
            ...routes.filter((route) => route.exact === false),
        ];

        return { menu: items.filter((item) => item.label), routes: orderedRoutes };
    }, [openNewCustomerDialog, ability, isRoot]);
};

/* Startseite, die der Benutzer laut seinen Rechten auch sehen darf: bevorzugt homePath,
   sonst der erste Menuepunkt ohne Parameter in der Route */
export const useHomePath = () => {
    const { routes } = useRouteItems();

    return useMemo(() => {
        if (routes.some((route) => route.to === homePath)) {
            return homePath;
        }

        const first = routes.find((route) => route.to && !route.to.includes(':'));

        return first ? first.to : homePath;
    }, [routes]);
};

export const useIsAllowedPath = () => {
    const { routes } = useRouteItems();

    return useCallback(
        (pathname) =>
            routes.some((route) =>
                matchPath(pathname, { path: route.to, exact: route.exact !== false })
            ),
        [routes]
    );
};
